import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { KeyboardArrowDownRounded as DownIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const CustomJourneySupportingLink = ({ accent, onClick, compact = false }) => (
  <ButtonBase
    onClick={onClick}
    sx={{
      width: '100%', justifyContent: 'space-between', textAlign: 'left',
      px: compact ? 1.4 : 1.6, py: compact ? 1.1 : 1.3, borderRadius: '18px',
      border: `1px solid ${alpha(accent.primary, 0.24)}`,
      bgcolor: alpha('#FFFFFF', 0.76),
    }}
  >
    <Box>
      <Typography sx={{ fontSize: '0.9rem', fontWeight: 780, color: accent.ink }}>
        Review supporting information
      </Typography>
      {!compact ? (
        <Typography sx={{ mt: 0.15, fontSize: '0.78rem', lineHeight: 1.4, color: alpha(colors.semantic.ink, 0.62) }}>
          See the records Lifelog used and check anything uncertain.
        </Typography>
      ) : null}
    </Box>
    <DownIcon sx={{ ml: 1, flexShrink: 0, color: accent.ink }} />
  </ButtonBase>
);

export default CustomJourneySupportingLink;
